import type { Account } from '@shared/products-types';
import type { Transaction } from '@shared/transactions-types';
import type { ProductWithHelpers } from '@shared/products-core';
import { useCards } from '@shared/cards-core';
import { useProducts } from '@retail/products-core';

import { getHistoryAccount } from './GettingAccountsForTransactions';

/**
 * Transactions can be associated to more than one product. This is the case
 * with Transactions made on Card.
 *
 * For example, a Transaction made on an Authorized (Supplemental) Card would be
 * associated with the Authorized Card, the Main Card, and the backing Account
 * for these Cards.
 */
export function useHistoryAccountForTransaction(
    transaction?: Transaction,
): ProductWithHelpers<Account> | undefined {
    const { products } = useProducts();
    const { cards } = useCards();
    if (!transaction) {
        return undefined;
    }
    const { owner, cardId } = transaction;
    return getHistoryAccount(products, cards, owner, cardId);
}
